<template>
  <div>
    
    <section class="seat_info_container display_none" :style="'height:' + container_height + 'px'">
        <!-- <main-head class="modal-header">
            <div class="f-gray_2 text_style title">
                劃位資訊
                <div class="f-gray_2 text_style left_arrow" @click="goback"></div>
            </div>
        </main-head> -->

            <section class="main_body">
                <div class="datepicker_container ">
                    <span class="title">選擇日期</span>
                    <div id="datepicker"></div>
                </div>

                <div class="timepicker_container">
                    <span class="title">劃位時間</span>
                    <div class="text">
                        <div id="time_slider"></div>
                        <div id="time_select"></div>
                    </div>
                </div>

                <div class="info_container ">
                    <span class="title">體驗者姓名</span>
                    <div class="text">
                        <input class="form-control" v-model="user_name" id="user_name" type="text" placeholder="姓名">
                    </div>
                </div>

                <div class="info_container ">
                    <span class="title">備註</span>
                    <div class="text">
                        <input class="form-control" v-model="user_remark" id="user_remark" type="text" placeholder="寫些備註吧!">
                    </div>
                </div>

                <div class="other_container">
                    <div class="title">劃位注意事項</div>
                    <ol>
                        <li>
                            〔取消劃位〕如需取消請先知會店家，若
                            為原預約時間24小時以前取消，則不會有
                            任何不良記錄。
                        </li>
                        <li>
                            〔修改劃位時間〕如欲修改劃位時間，請
                            先取消劃位後再次申請。
                        </li>
                        <li>
                            送出申請後48小時對方沒有確認則自動取
                            消申請。
                        </li>
                        <li>
                            兩人同行(一券兩個人用)須自行提供店家另
                            一位體驗者資料。
                        </li>
                        <li>
                            一張票僅可在一間店劃位。
                        </li>
                        <li>
                            加入SPA99 官方LINE@並綁定購買帳號，
                            即可享店家劃位確認及劃位提醒等通知。
                        </li>
                    </ol>
                </div>

                <div class="other_container check" @click="post_ticket_option()">確認送出</div>
            </section>
       
    </section>
  </div>
</template>


<script>
var that;
export default {
  name: '',
  components:{
    
  },
  props: [
    
  ],
  data: function () {
    return {
        //容器高度
        container_height:0,
        //劃位資訊
        user_name:this.$bus.user_info.user_name,
        user_remark:'',
        chooser:{}
    }
  },
  computed: {
  },
  created() {
  },
  mounted () {
    that = this;
    that.init();
  },
  methods: {
    init:function(){
        that.handle_container_height();
        that.init_datepicker();
        that.init_timepicker();
    },
    handle_container_height:function(){
        that.container_height = $(window).height()
                            -$('.navbar')[0].offsetHeight
                            -($('.bottom-navigator')[0]?$('.bottom-navigator')[0].offsetHeight:0)
                            -$('.top_header')[0].offsetHeight - 10;
    },
    post_ticket_option:function(){
        //紀錄日期
        that.$bus.invitation_info={
            user_name:that.user_name,
            user_remark:that.user_remark,
            date:$('#datepicker').datepicker().val()+' '+
                 that.chooser.result.get_val()['value']+':'+
                 that.chooser.result.get_val1()['value']+':'+
                 '00'
        }
        that.$bus.$emit('post_ticket_option',that.$bus.invitation_ticket);
        
    },
    //日期選擇器init
    init_datepicker: function () {
        //------------------------------------------月曆----------------------------------------------------------
        //將預設語系設定為中文
        $.datepicker.setDefaults({
            dayNamesMin:["日","一","二","三","四","五","六"],
            monthNames:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],
            yearSuffix: '年',
            showMonthAfterYear: true,
            minDate: '+1d',
            //可選範圍
//                maxDate: '+1y+2m',
//                maxDate: '+1y',
            dateFormat: 'yy-mm-dd'
        });
        $("#datepicker").datepicker({
            //callback
            onSelect: function() {
                console.log($(this).datepicker().val())
            }
        });
    },
    //時間選擇器init
    init_timepicker: function () {
        var hh_data = [],mm_data = [],hh=0,mm=0,mm_new;
        for(;hh<24;hh++){
            hh = hh < 10 ? '0'+hh:hh;
            hh_data.push(
                {   
                    class:'one',
                    id:hh,
                    value:hh
                }
            )
        }
        for(;mm<60;mm += 5){
            mm_new = mm < 10 ? '0'+mm:mm;
            mm_data.push(
                {
                    class:'two',
                    id:mm_new,
                    value:mm_new
                }
            )
        }
        that.chooser=new MobileSelect({
            trigger: '#time_slider',
            trigger_select: '#time_select',
            wheels: [
                {data:hh_data},
                {data:mm_data}
            ],
            position:[0,0]
        });
        $(window).resize(function(){
            that.chooser.resize()
            if (navigator.userAgent.match(/Android/i)
                || navigator.userAgent.match(/webOS/i)
                || navigator.userAgent.match(/iPhone/i)
                || navigator.userAgent.match(/iPad/i)
                || navigator.userAgent.match(/iPod/i)
                || navigator.userAgent.match(/BlackBerry/i)
                || navigator.userAgent.match(/Windows Phone/i)
            ) {
                //手機版
                $('#time_slider').show();
                $('#time_select').hide();
            }
            else {
                //桌機版
                $('#time_select').show();
                $('#time_slider').hide();
            }
        }).resize();
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .seat_info_container{
        overflow: auto;
    .main_body{
        // height: calc(100vh - 47px);
        // width: 100vw;
        background-color: #e5e5e5;
        padding: 10px;
        transition: 0.2s;
    }
    
  }
</style>
<style lang="scss">
   .ui-datepicker-header{
       position: relative;
   }
   .ui-icon{
       display: none;
   }

    /*劃位資訊*/
    #datepicker{
        /*margin-top: 50px;*/
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .seat_info_container .ui-datepicker-inline{
        width: 100%;
    }
    .seat_info_container .ui-datepicker-calendar {
        width: 100%;
        margin: 0;
    }
    .seat_info_container .ui-widget.ui-widget-content{
        border: 0;
    }
    .seat_info_container .ui-widget-header{
        border: 0;
        background: #fff;
    }
    .seat_info_container .ui-datepicker-title{
        font-size: 24px;
        color:var(--main-color);
        font-family: NotoSansCJKtc;
        font-size: 24px;
        line-height: 1.25;
        // letter-spacing: 1.2px;
        margin: 10px 0;

    }
    .seat_info_container .ui-icon{
        background-image:none!important;
    }
    .seat_info_container  .ui-datepicker-next
    {
        right: 20px!important;
    }
    .seat_info_container  .ui-datepicker-prev
    {
        position: absolute;
        left: 10px;
    }
    .seat_info_container .ui-datepicker-prev:before{
        content:'';
        height: 12px;
        width: 12px;
        border-top: 3px solid var(--main-color);
        border-left: 3px solid var(--main-color);
        position: absolute;
        left:13px;
        top: 10px;
        transform: rotate(-45deg);
    }
    .seat_info_container .ui-datepicker-next:before{
        content:'';
        height: 12px;
        width: 12px;
        border-top: 3px solid var(--main-color);
        border-right: 3px solid var(--main-color);
        position: absolute;
        right:20px;
        top: 10px; 
        transform: rotate(45deg);
    }
    .ui-datepicker-calendar,
    .ui-state-default{
        color:#cccccc!important;
    }
    .seat_info_container .ui-datepicker-calendar{
        font-size: 22px;
    }
    .seat_info_container .ui-widget-content .ui-state-default{
        border:0!important;
        padding: 10px;
        text-align: center;
        font-size: 18px;
        background:none;
        border-radius: 50%;
    }

    .seat_info_container .ui-state-default.ui-state-active,
    .seat_info_container .ui-state-default.ui-state-active.ui-state-highlight{
        background:var(--main-color)!important;
        color: white!important;

    }
    .seat_info_container .ui-state-default.ui-state-highlight{
        background: #fffa90!important;
        color: #696666!important;
    }
    .seat_info_container .ui-state-default{
        font-family: STHeitiTC;
        width:35px;
        height: 35px;
        margin: 0 auto;
        margin-bottom: 20px;
        align-items: center;
        justify-content: center;
        display: flex;
    }

    .datepicker_container,
    .timepicker_container,
    .info_container
    {
        background: #ffffff;
        text-align: center;
        padding:15px 0;
        border-radius: 10px;
        margin-bottom: 16px;
    }
    .other_container{
        background: none;
        text-align: left;
        padding-left: 15px;
        padding-right: 15px;
    }
    .datepicker_container .title,
    .timepicker_container .title,
    .info_container .title
    {
        font-family: NotoSansCJKtc;
        font-size: 1.2rem;
        font-weight: 500;
        line-height: 1.36;
        text-align: center;
        color: #585858;
    }
    .timepicker_container,
    .info_container
    {
        align-items: center;
        justify-content:center;
        display: flex;
    }
    .timepicker_container .title,
    .info_container .title
    {
        width: 40%;
        /*justify-content: flex-start;*/
        margin-left: 19px;
    }
    .info_container .title{
        width: 35%;
    }
    .info_container .title{
        text-align: left;
    }
    .timepicker_container .text,
    .info_container .text
    {
        flex: 1;
        /*justify-content: flex-end;*/
    }
    .info_container .text{
        text-align: left;
    }
    .info_container input{
        border: 0;
    }

    .other_container .title{
        font-family: MicrosoftJhengHei;
        font-size: 21.5px;
        text-align: left;
        color: #222222;
        margin-bottom: 10px;
    }
    .other_container ol li{
        font-family: MicrosoftJhengHei;
        font-size: 18px;
        line-height: 1.33;
        color: #555555;
        margin-left: 22px;
        margin-bottom: 5px;
        font-weight: 150;
    }
    .check{
        margin:  0 10px;
        flex: 1;
        font-size: 20px;
        background-color: var(--main-color);
        color: white;
        padding:10px;
        border-radius: 10px;
        text-align: center;
    }

    /*timepicker*/
    .gear{
        font-size: 16px;
    }
    .gearDate,
    .gearDatetime{
        position: absolute!important;
        z-index:0!important;
    }
    .timepicker_container .text{
        position: relative;
        min-height: 100px;
    }
    .date_ctrl{
        background-color: #ffffff!important;
        bottom: -95px!important;

    }
    .time_mm .tooth{
        text-align: center;
        margin-left: 27px;
        color: black;
    }

    .tooth.active{
        color: #dd6f9d;
        font-size: 20px;
        transition: 0.3s;
    }
    .timepicker_container .mobileSelect .content .panel .wheels,
    .timepicker_container .mobileSelect .content .panel .wheel,
    #view_choose_store .wheels{
        height: 120px;
    }
    #view_choose_store .selectLine{
        top: 39px;
    }
    #view_choose_store .selectContainer{
        position: relative;
        top: -40px;
    }
    .timepicker_container .mobileSelect .content .panel .shadowMask,
    #view_choose_store .shadowMask{
        background: unset;
    }
    .timepicker_container .mobileSelect ul li,
    #view_choose_store ul li{
        color:#555;
    }
    .timepicker_container .mobileSelect ul li{
        font-size: 14px!important;
    }
    .timepicker_container .mobileSelect ul li.active,
    #view_choose_store ul li.active{
        color:var(--main-color);
        font-size: 23px!important;
    }

    .timepicker_container .selectContainer{
        top: -40px;
        position: relative;
    }

    /*mobileSelect*/
    .mobileSelect {
        position: relative;
        z-index: 0;
        opacity: 0;
        visibility: hidden;
        -webkit-transition: opacity 0.4s, z-index 0.4s;
        transition: opacity 0.4s, z-index 0.4s;
    }
    .mobileSelect * {
        margin: 0;
        padding: 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
    .mobileSelect .grayLayer {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: #eee;
        background: rgba(0, 0, 0, 0.7);
        z-index: 888;
        display: block;
    }
    .mobileSelect .content {
        width: 100%;
        display: block;
        position: relative;
        z-index: 889;
        color: black;
        -webkit-transition: all 0.4s;
        transition: all 0.4s;
        top: 0;
        left: 0;
        background: white;
    }
    .mobileSelect .content .fixWidth {
        width: 90%;
        margin: 0 auto;
        position: relative;
    }
    .mobileSelect .content .fixWidth:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }
    .mobileSelect .content .btnBar {
        border-bottom: 1px solid #DCDCDC;
        font-size: 15px;
        height: 45px;
        position: relative;
        text-align: center;
        line-height: 45px;
    }
    .mobileSelect .content .btnBar .cancel,
    .mobileSelect .content .btnBar .ensure {
        height: 45px;
        width: 55px;
        cursor: pointer;
        position: absolute;
        top: 0;
    }
    .mobileSelect .content .btnBar .cancel {
        left: 0;
        color: #666;
    }
    .mobileSelect .content .btnBar .ensure {
        right: 0;
        color: #1e83d3;
    }
    .mobileSelect .content .btnBar .title {
        font-size: 15px;
        padding: 0 15%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .mobileSelect .content .panel:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }
    .mobileSelect .content .panel .wheels {
        width: 100%;
        height: 200px;
        overflow: hidden;
    }
    .mobileSelect .content .panel .wheel {
        position: relative;
        z-index: 0;
        float: left;
        width: 50%;
        height: 200px;
        overflow: hidden;
        -webkit-transition: width 0.3s ease;
        transition: width 0.3s ease;
    }
    .mobileSelect .content .panel .wheel .selectContainer {
        display: block;
        text-align: center;
        -webkit-transition: -webkit-transform 0.18s ease-out;
        transition: -webkit-transform 0.18s ease-out;
        transition: transform 0.18s ease-out;
        transition: transform 0.18s ease-out, -webkit-transform 0.18s ease-out;
    }
    .mobileSelect .content .panel .wheel .selectContainer li {
        font-size: 19px;
        display: block;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .mobileSelect .content .panel .selectLine {
        height: 40px;
        width: 100%;
        position: absolute;
        top: 80px;
        pointer-events: none;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        /*border-top: 1px solid #DCDCDC;*/
        /*border-bottom: 1px solid #DCDCDC;*/
    }
    .mobileSelect .content .panel .shadowMask {
        position: absolute;
        top: 0;
        width: 100%;
        height: 200px;
        background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), color-stop(rgba(255, 255, 255, 0)), to(#ffffff));
        background: -webkit-linear-gradient(top, #ffffff, rgba(255, 255, 255, 0), #ffffff);
        background: linear-gradient(to bottom, #ffffff, rgba(255, 255, 255, 0), #ffffff);
        opacity: 0.9;
        pointer-events: none;
    }
    .mobileSelect-show {
        opacity: 1;
        z-index: 10000;
        visibility: visible;
    }
    .mobileSelect-show .content {
        bottom: 0;
    }
    #store_select{
        text-align: center;
        margin-bottom: 20px;
    }
    #store_select select{
        border: 0px;
        font-size: 20px;
        flex: 1;
        /*margin-right: 10px!important;*/
        color: var(--main-color);
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 1px;
        text-overflow: '';
        outline: none;
        background-color: white;
    }
    #store_select:before{
        content: '';
        height: 10px;
        width: 10px;
        border-top: 2px solid gray;
        border-right: 2px solid gray;
        position: absolute;
        top: 28px;
        left: 49%;
        transform: rotate(133deg);
    }

    #time_select{
        display: flex;
        top: 37px;
        position: relative;
    }
    #time_select select{
        text-align-last:center;
        border: 0px;
        font-size: 20px;
        flex: 1;
        margin-right: 10px!important;
        color: var(--main-color);
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 1px;
        text-overflow: '';
        outline: none;
        background-color: white;
    }
</style>
